import {
  IDeliverySimulationResponse,
  IDeliverySimulationRequest,
  IDeliveryTrackingResponse,
} from "shared/interfaces/IDelivery";
import { api } from "../api";

/* ===================================
   CALCULAR FRETE
=================================== */

export const calcularFreteCarrinho = async (
  data: IDeliverySimulationRequest
): Promise<IDeliverySimulationResponse> => {
  const response = await api.post(
    "/cart/delivery-simulation",
    data
  );

  return response.data;
};

/* ===================================
   BUSCAR DELIVERY DO PEDIDO
=================================== */

export const buscarDeliveryPedido = async (
  orderId: string
): Promise<IDeliveryTrackingResponse> => {
  const response = await api.get(
    `/delivery/order/${orderId}`
  );

  return response.data;
};

/* ===================================
   BUSCAR DELIVERY DO PEDIDO - LOJISTA
=================================== */

export const buscarDeliveryPedidoLoja = async (
  orderId: string
): Promise<IDeliveryTrackingResponse> => {
  const response = await api.get(
    `/delivery/store/order/${orderId}`
  );

  return response.data;
};